var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg75Stats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    r: 93.5,
    fill: "#35A097",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9863 93.3862C45.9863 90.5212 48.3093 88.1982 51.1743 88.1982C54.0393 88.1982 56.3623 90.5212 56.3623 93.3862C56.3623 96.2512 54.0393 98.5742 51.1743 98.5742C48.3093 98.5742 45.9863 96.2512 45.9863 93.3862Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9258 93.3862C98.9258 90.5212 101.249 88.1982 104.114 88.1982C106.979 88.1982 109.302 90.5212 109.302 93.3862C109.302 96.2512 106.979 98.5742 104.114 98.5742C101.248 98.5742 98.9258 96.2512 98.9258 93.3862Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.22 116.885C105.035 130.345 92.4804 140.118 77.6434 140.118C62.8064 140.118 50.2514 130.345 46.0664 116.885",
    stroke: "white",
    strokeWidth: 4.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg75Stats);
export default __webpack_public_path__ + "static/media/75-stats.db01af218d945971305e1786abc86966.svg";
export { ForwardRef as ReactComponent };